import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getSlider } from './actions';
import './style.scss';
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent';
import classNames from 'classnames';
import { Result } from 'antd';
import SliderBlockContent from './components/SliderBlockContent/SliderBlockContent';

export class SliderVIew extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      sliders: [],
    }
  }

  async componentDidMount(){
    const {items} = await getSlider(this.props.match.params.id);
    this.setState({
      loaded: true,
      sliders: items,
    })
  }


  render() {
    const {sliders, loaded} = this.state;
    const {formatMessage} = this.props;

    if(!loaded){
      return null;
    }

    if(sliders.length == 0){
      return <Result
      status="500"
      title={formatMessage('titleNotFoundSlider')}
      subTitle={formatMessage('msgNotFoundSlider')}
    />
    }
   
    return (<div className='SliderViewBlock'>
      <SliderBlockContent items={sliders} />
    </div>)
  }
}

export default WrappedIntlComponent(SliderVIew)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/SliderVIew/SliderVIew.jsx